"use client";

import { useState, useEffect } from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { PricingTable } from "@/components/marketing/pricing/pricing-table";
import { FeatureTable } from "@/components/marketing/pricing/feature-table";
import { TitleWithBadge } from "@/components/marketing/title-with-badge";
import type { Plan as PlanType } from "@/components/marketing/pricing/types";
import axios from "axios";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import React from "react";

const poorCountries = [
  "AR",
  "BO",
]

const richCountries = [
  "US",
  "ES",
]

const spinnerVariants =
  "w-16 h-16 border-4 border-t-4 border-gray-200 border-t-gray-600 rounded-full animate-spin";

type LoadingSpinnerProps = {
  className?: string;
};

const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerProps>((props, ref) => {
  const { className, ...rest } = props;
  return <div ref={ref} className={cn(spinnerVariants, className)} {...rest} />;
});

export default function PricingPage() {

  const [isAnnual, setIsAnnual] = useState<boolean>(false);
  const t = useTranslations("pricing");
  const [dynamicPlans, setDynamicPlans] = useState<any>([]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const staticPlans: PlanType[] = [

    // {
    //   "name": t("plans.0.title"),
    //   "codeName": t("plans.0.codeName"),
    //   "price": { yearly: '16', monthly: 20, isCustom: false },
    //   "description": t("plans.0.description"),
    //   "cta": t("getStarted"),
    //   "ctaLink": "/blog/get-started",
    //   "features": {
    //     platform: {
    //       "invitationsMonth": 800,
    //       "creditsMonth": 2200,
    //       "bulkSend": true,
    //       "followUp": true,
    //     },
    //     support: {
    //       "salesStrategyMeetings": false,
    //       "community": true,
    //       "support": false,
    //       "dedicatedAI": false,
    //       "customFeatures": false,
    //       "offerOptimization": false
    //     }
    //   }
    // },
    {
      "name": t("plans.1.title"),
      "codeName": t("plans.1.codeName"),
      "price": { yearly: 50, monthly: 50, isCustom: false },
      "description": t("plans.1.description"),
      "popular": true,
      "cta": t("getStarted"),
      "ctaLink": "/blog/get-started",
      "features": {
        platform: {
          "invitationsMonth": 2400,
          "creditsMonth": '12k',
          "bulkSend": true,
          "followUp": true,
        },
        support: {

          "salesStrategyMeetings": false,
          "community": true,
          "support": true,
          "dedicatedAI": false,
          "customFeatures": false,
          "offerOptimization": false
        }
      }
    },

    {
      "name": t("plans.2.title"),
      "codeName": t("plans.2.codeName"),
      "price": { yearly: t("custom"), monthly: t("custom"), isCustom: true },
      "cta": t("contactSales"),
      "description": t("plans.2.description"),
      "ctaLink": "/contact",
      "features": {
        platform: {
          "invitationsMonth": t("custom"),
          "creditsMonth": t("custom"),
          "bulkSend": true,
          "followUp": true,
        },
        support: {
          "salesStrategyMeetings": true,
          "community": true,
          "support": true,
          "dedicatedAI": true,
          "customFeatures": true,
          "offerOptimization": true
        },
      }
    },
  ];
  const [plans, setPlans] = useState<PlanType[]>(staticPlans);

  useEffect(() => {
    axios.get("https://api.theos.ai/v1/assistant/linkedin/plans/").then((response) => {
      const responsePlans = response.data;
      setDynamicPlans(response.data);
      setLoaded(true);

      const newPlans = [...staticPlans];
      newPlans.forEach((plan) => {
        const dynamicPlan = responsePlans.find((dynamicPlan) => (dynamicPlan.plan_code === plan.codeName) && !dynamicPlan.price.isCustom);
   
        if (dynamicPlan) {
          plan.price.monthly = dynamicPlan.price;
        }
      });
      setPlans(newPlans);
    });
  }, []);





  return (
    <main className="container flex flex-col items-center py-8 flex-start">
      <div className="max-w-screen-lg">
        <TitleWithBadge
          title={t("title")}
          //  badgeText="Artificial Intelligence"
          //  badgeIcon={WandSparkles}
          description={t("description")}
        />
        {loaded ?
          <>
            <PricingTable plans={plans} isAnnual={isAnnual} setIsAnnual={setIsAnnual} />
            {/* <TitleWithBadge
              className="mb-0 md:mb-0 mt-20"
              title={t("compareFeatures.title")}
              //  badgeText="Artificial Intelligence"
              //  badgeIcon={WandSparkles}
              description={t("compareFeatures.description")}
            /> */}
            {/* <FeatureTable plans={plans} isAnnual={isAnnual} setIsAnnual={setIsAnnual} /> */}
          </>
          :
          <div className="flex justify-center items-top h-[1200px]">
            <LoadingSpinner />
          </div>
        }
      </div>
    </main>

  );
}
